import { createSlice } from '@reduxjs/toolkit';
import { REDUCER_MENU_NAME } from '#baseMenu/constants';
import { StateMenu } from '#baseMenu/types/StateMenu';

const initialState: StateMenu = {
  isVisibleButtonForAdvertContacts: false,
};

const sliceMenu = createSlice({
  name: REDUCER_MENU_NAME,
  initialState,
  reducers: {
    showButtonForAdvertContacts: (state) => {
      state.isVisibleButtonForAdvertContacts = true;
    },
    hideButtonForAdvertContacts: (state) => {
      state.isVisibleButtonForAdvertContacts = false;
    },
  },
});

const reducerMenu = sliceMenu.reducer;

const {
  showButtonForAdvertContacts,
  hideButtonForAdvertContacts,
} = sliceMenu.actions;

export {
  reducerMenu,
  showButtonForAdvertContacts,
  hideButtonForAdvertContacts,
};
